export default __webpack_public_path__ + "static/media/projectpage.9f227a85.png";